<template>
  <section class="button-inputs">
    <section-title>ButtonInput Component</section-title>
    <form-wrap>
      <form-field-set>
        <div class="space">
          <button-input>
            Normal Button
          </button-input>
        </div>

        <div class="space">
          <button-input color="grey">
            Grey Button
          </button-input>
        </div>

        <div class="space">
          <button-input color="error">
            Error Button
          </button-input>
        </div>

        <div class="space">
          <button-input :is-disabled="true">
            Disabled Button
          </button-input>
        </div>

        <div class="space">
          <button-input size="big">
            Big Button
          </button-input>
        </div>

        <div class="space">
          <button-input size="full">
            Full Button
          </button-input>
        </div>

        <div class="space">
          <button-input size="square">
            Sqare
          </button-input>
        </div>

      </form-field-set>
    </form-wrap>
  </section>
</template>

<script>
import PlaygroundCommmonMixin from '@/mixins/pages/playground/PlaygroundCommon'
import ButtonInput from '@/components/ui/ButtonInput'
import FormFieldSet from '@/components/forms/FormFieldSet'
import FormWrap from '@/components/forms/FormWrap'
import SectionTitle from '@/components/ui/SectionTitle'

export default {
  name: 'ButtonInputs',
  mixins: [PlaygroundCommmonMixin],
  components: {
    ButtonInput,
    FormFieldSet,
    FormWrap,
    SectionTitle
  }
}
</script>

<style lang="sass">
.space
  margin: 20px 0
</style>



// WEBPACK FOOTER //
// src/pages/playground/ButtonInputs.vue